(() => {
  function updateLink(link) {
    if (!(link instanceof HTMLAnchorElement)) return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    const url = new URL(href, document.baseURI);
    if (url.origin !== location.origin || !/\/collections\/[^/]+\/?$/.test(url.pathname)) return;
    if (url.search || url.hash) return;
    url.searchParams.set('sort_by', 'created-descending');
    link.setAttribute('href', `${url.pathname}${url.search}`);
  }

  function updateLinks(root) {
    if (root instanceof HTMLAnchorElement) updateLink(root);
    root.querySelectorAll('a[href]').forEach(updateLink);
  }

  updateLinks(document);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') {
        updateLink(record.target);
      } else {
        record.addedNodes.forEach(node => {
          if (node instanceof Element) updateLinks(node);
        });
      }
    });
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['href'],
  });
})();
